import { START, QUOTED, PRICE_SELECTED, ERROR } from 'pu-data/QuoteSteps';
import {
  QUOTE_SUCCESS,
  QUOTE_FAILURE,
  SELECT_PRICE_SUCCESS,
} from 'pu-redux/actions/QuoteActions';

const step = (state = START, action) => {
  switch (action.type) {
    case QUOTE_SUCCESS:
      if (!action.quote || !action.quote.line_items) { return ERROR; }
      return QUOTED;

    case QUOTE_FAILURE:
      return ERROR;

    case SELECT_PRICE_SUCCESS:
      return PRICE_SELECTED;

    default:
      return state;
  }
};

export default step;
